module.exports = __webpack_public_path__ + "static/media/functional@2x.1a40d390.png";